import { render, staticRenderFns } from "./DeclineProposalPopup.view.vue?vue&type=template&id=292ca7ce&"
import script from "./DeclineProposalPopup.view.vue?vue&type=script&lang=js&"
export * from "./DeclineProposalPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292ca7ce')) {
      api.createRecord('292ca7ce', component.options)
    } else {
      api.reload('292ca7ce', component.options)
    }
    module.hot.accept("./DeclineProposalPopup.view.vue?vue&type=template&id=292ca7ce&", function () {
      api.rerender('292ca7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/protocol/DeclineProposalPopup.view.vue"
export default component.exports